import { useMemo } from 'react';

import { getCustomerPlan, isPlanFromBusinessCategory } from 'src/data/subscription';
import { ROUTES } from 'src/routes';
import { useBookDemoInfo } from 'src/services/useBookDemoInfo';
import { useCurrentCustomer } from 'src/store';

export const useGetUpgradeRowsLimitButtonAttributes = () => {
  const currentCustomer = useCurrentCustomer();
  const { bookDemoUrl } = useBookDemoInfo();

  return useMemo(() => {
    const subscriptionPlan = getCustomerPlan(currentCustomer);
    const isBusinessPlan = isPlanFromBusinessCategory(subscriptionPlan);
    const upgradeRoute = isBusinessPlan && bookDemoUrl ? bookDemoUrl : ROUTES.UPGRADE;
    const upgradeButtonText = isBusinessPlan ? 'Contact sales' : 'Upgrade';

    return {
      upgradeRoute,
      upgradeButtonText,
      isBusinessPlan,
    };
  }, [currentCustomer, bookDemoUrl]);
};
